<template>
  <UIDrawer
    :is-open
    :z-index
    title="JSON data"
    :allow-tray
    @close="handleClose"
    @minimize="handleMinimize"
  >
    <UIJsonTree :json size="sm">JSON data</UIJsonTree>
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { UIJsonTree } from '@ui/core'
import { UIDrawer } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
  json: Record<string, unknown>
}
const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleClose = () => {
  props.modal.close()
}

const handleMinimize = () => {
  props.modal.hide()
}
</script>
